import axios from 'axios'
// 创建连接
export const createConnection = params => { return axios.post(`/database/createconnection`, params).then(res=>res.data); };

// 获取连接
export const getConnection = params => { return axios.post(`/database/getconnection`, params).then(res=>res.data); };

//获取数据库
export const getDatabases = params => { return axios.post(`/database/getdatabases`, params).then(res=>res.data); };

//获取数据表
export const getTables = params => { return axios.post(`/database/gettables`, params).then(res=>res.data); };




// WEBPACK FOOTER //
// ./src/api/database/database.js